/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorNewScorecardAttributeNewRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'monitor.new-scorecard.attribute-new',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorNewScorecardAttributeNewRoute);
